import {AiSetupJobDetail, AiSetupJobInfo} from "../../fund/generated-sources/api";
import {ApiDataModel} from "../../shared/model/api-data-model";

export interface FundAiSetupState {
    jobsByFund: { [fundId: number]: ApiDataModel<AiSetupJobInfo[]> };
    activeDetail: ApiDataModel<AiSetupJobDetail | undefined>;
    pendingActionResultIds: number[];
    error?: string;
}

export const initialFundAiSetupState: FundAiSetupState = {
    jobsByFund: {},
    activeDetail: {data: undefined, status: "INIT", errorMessage: ""},
    pendingActionResultIds: []
};
